import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type { NextPageContext } from 'next';
import { apolloClient } from '@/api/apolloClient';
import { GET_SHOP_DETAILS } from '@/api/queries/shop.queries';
import type { ShopDetails } from '@/api/types/shop.types';

interface GetShopDetailsResponse {
  ShopDetails: ShopDetails | null;
}

export async function getServerShopDetails(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
): Promise<ShopDetails | null> {
  const slugParam = context.query.slug;
  const slug = (Array.isArray(slugParam) ? slugParam[0] : slugParam) ?? '';

  if (!slug) return null;

  const shopDetails = await apolloClient<GetShopDetailsResponse>(
    client,
    {
      query: GET_SHOP_DETAILS,
      variables: { slug },
      errorPolicy: 'all',
    },
    context
  );

  return shopDetails?.data?.ShopDetails ?? null;
}
